import React, { Component } from 'react';
import _ from 'lodash';
import cx from 'classnames';

import Avatar from '@material-ui/core/Avatar';
import { withStyles } from '@material-ui/core/styles';
import { Theme } from '@material-ui/core/styles/createMuiTheme';
import {
  WithStyles,
  createStyles,
  Card,
  CardContent,
  Link,
  Grid,
  Typography,
  List,
  ListItem,
  ListItemText,
  ListItemSecondaryAction,
  IconButton,
} from '@material-ui/core';

import PerfectScrollbar from 'react-perfect-scrollbar';
import KeyboardArrowRightIcon from '@material-ui/icons/KeyboardArrowRight';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';
import { MyPATLocalLoader } from '../../common';

import GoalDrillerData from '../types/GoalDrillerData';
import CourseData from '../types/CourseData';
import CourseSyllabusData from '../types/CourseSyllabusData';
import { ContentListFilterData } from '../types/ContentFilterData';

import courseService from '../services/courseService';
import contentService from '../services/contentService';
import CustomInfoIcon from '../../common/CustomInfoIcon';
import { iconsForSubjects } from '../../../utils';

const styles = (theme: Theme) =>
  createStyles({
    purple: {
      border: 'solid 1px #78d2a7',
      background: 'rgb(255 255 255)',
      width: '25px',
      height: '25px',
      margin: '0 8px 0 0',
      fontSize: '10px',
      color: '#1d7dea',
    },
    paddingLeftMD: {
      paddingLeft: 26,
    },
    goalListItem: {
      minHeight: 30,
      position: 'relative',
      display: 'flex',
      alignItems: 'center',
      '& img': {
        padding: '2px 10px 0px 10px',
      },
      '& label': {
        cursor: 'pointer',
        maxWidth: 200,
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        zIndex: 9,
        '&>:nth-child(1)': {
          color: 'rgb(51 51 51)',
          fontSize: 16,
          fontWeight: 400,
        },
        '&>:nth-child(2)': {
          color: 'rgb(51 51 51)',
          fontSize: 12,
          fontWeight: 300,
        },
      },
      '&>:nth-child(1)>svg': {
        fill: '#666',
        fontSize: 18,
        fontWeight: 'bold',
        marginTop: -3,
      },
      cursor: 'pointer',
      '& span':{
        zIndex: 9,
      },
      '& .tooltip': {
        display: 'none',
      },
      '&:hover': {
        '& .tooltip': {
          display: 'block',
          position: 'absolute',
          background: 'rgb(222 222 222)',
          width: '95%',
          left: 0,
          zIndex: 999,
          top: 34,
          padding: 12,
          color: 'rgb(51 51 51)',
          lineHeight: '20px',
          fontWeight: 600,
          '&::before': {
            left: '30%',
            width: 0,
            top: -8,
            height: 0,
            content: '" "',
            position: 'absolute',
            marginLeft: -6,
            borderLeft: '5px solid rgb(0 0 0 / 0%)',
            borderRight: '5px solid rgb(0 0 0 / 0%)',
            borderBottom: '8px solid rgb(222 222 222)',
          },
        },
      },
      selectedListItem: {
        '&::before': {
          background: '#CDE8FF',
          content: '" "',
          height: 38,
          width: '100%',
          position: 'absolute',
          left: 0,
          zIndex: 0,
        },
      },
      treeToggleLabel: {
        verticalAlign: 'middle',
        cursor: 'pointer',
        fontSize: 14,
        overflow: 'hidden',
        whiteSpace: 'nowrap',
        margin: '4px 5px 0px',
      },
      '&>:first-child': {
        color: '#333333',
        fontSize: 14,
        fontWeight: 'bold',
        zIndex: 9,
        '&>span': {
          color: 'rgb(102 102 102)',
          fontSize: 12,
          fontWeight: 400,
        },
      },
      '&>:second-child': {
        color: '#666666',
      },
    },
    goalLevelList: {
      padding: '0px 4px',      
      height: 'calc(100vh - 90px)',
      overflow: 'auto',
      '& li': {
        listStyle: 'none',
        fontSize: 14,
        lineHeight: '15px',
        color: 'rgb(51 51 51)',
        padding: '0px 0px 0px 8px',
        '& img': {
          padding: '0px 10px 0px 4px',
        },
        // '&:hover':{
        // 	'&::before': {
        // 		background: '#CDE8FF',
        // 		content: '" "',
        // 		height: 38,
        // 		width: '100%',
        // 		position: 'absolute',
        // 		left: 0,
        // 		zIndex: 0
        // 	} Will Use later
        // }
      },
      '& li>span>img': {
        verticalAlign: 'middle',
        cursor: 'pointer',
      },
      '& ul': {
        padding: '0px 0px 0px 0px',
        margin: '5px 0px',
      },
      '& li>span': {
        padding: '0px 6px 0px 0px',
        height: 24,
        color: 'rgb(102 102 102)',
      },
    },
    hideChildNode: {
      display: 'none',
    },
    showChildNode: {
      display: 'block',
    },
    fontSizeSM: {
      fontSize: '0.75rem !important',
    },
    paddingSM: {
      padding: '2px 0px',
      margin: '-18px -16px 14px -16px',
    },
    textColor: {
      color: '#999999',
    },
    goalListBlock: {
      '& .ps--active-x > .ps__rail-x, .ps--active-y > .ps__rail-y': {
        width: 10,
        backgroundColor: '#eee',
        marginTop: 15,
      },
      '& .ps__thumb-y, .ps__rail-y:hover > .ps__thumb-y': {
        backgroundColor: '#999',
        width: 6,
      },
      '& ::backdrop':{
        position:'fixed',
        right:0,
        top:0,
        bottom:0,
        left:0,
        background:'#cc0000',
        width:1000,
        height:'100%',
        display:'block',
      },
    },

    cardContainer: {
      background: 'rgb(255 255 255)',
      boxShadow: '0px 0px 10px rgba(0, 0, 0, 0.1)',
      boxSizing: 'border-box',
      borderRadius: 8,
    },
    noBorderRadius:{
      borderRadius:'0 !important',
    },
    goalsCategoriesNav: {
      position: 'absolute',
      left: 0,
      top: -48,
      width: '70vw',
    },

    infoIcon: {
      position: 'relative',
      top: -2,
    },
    truncateList: {
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      width: 180,
      zIndex: 99999,
      position: 'absolute',
      color: '#666666',
    },
    listTruncate: {
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      maxWidth: 100,
    },
    ulDefault: {
      padding: 0,
      margin: 0,
      transition: 'all 0.5s ease',
      paddingTop: '5px',
    },
    listItem: {
      display: 'inline-block',
      padding: '0 8px 0',
      paddingBottom: 0,
      cursor: 'pointer',
    },
    listItemLinks: {
      fontFamily: 'Nunito !important',
      fontWeight: 'normal',
      fontSize: '14px !important',
      lineHeight: '18px !important',
      textDecoration: 'underline !important',
      color: '#666666 !important',
    },
    categoryListItem: {
      background: '#FFFFFF',
      border: '1px solid #EBEBEB',
      boxSizing: 'border-box',
      borderRadius: 4,
      cursor: 'pointer',
      margin: '0px 15px 10px 7px',
      '& li > span': {
        color: 'rgba(50, 60, 71, 1)',
        fontSize: 1,
        fontFamily: "'Nunito/', sans-serif",
        fontWeight: 400,
        lineHeight: 1.5,
      },
      '&:hover .tooltipContainer': {
        display: 'block',
        '& :first-child': {
          maxWidth: 300,
          whiteSpace: 'normal',
          textAlign: 'center',
        },
      },
      '& .tooltipContainer': {
        display: 'none',
      },
    },

    linkItem: {
      fontFamily: 'Nunito',
      fontStyle: 'normal',
      fontWeight: 'normal',
      fontSize: 14,
      color: '#999999',
      lineHeight: 1.8,
      '& .active, :active, :focus, :hover': {
        color: theme.palette.primary.main,
      },
    },
    marginBottom1x: {
      marginBottom: theme.spacing.unit,
    },
    marginBottomTop2x: {
      position: 'relative',
      marginBottom: 16,
      marginTop: 0,
    },
    paddingZero: {
      padding: 0,
    },
    currentLevel: {
      padding: '0px 0px 0 px 20px',
      background: '#fff',
      transition: 'all 0.5s ease',
      maxHeight: 40,
      textTransform: 'capitalize',
      fontFamily: 'Nunito',
      fontStyle: 'normal',
      fontWeight: 600,
      fontSize: 16,
      lineHeight: '22px',
      alignItems: 'flex-end',
      color: '#333333',
      display: 'flex',
      justifyContent: 'space-between',
    },
    displayFlex: {
      display: 'flex',
    },
    cardContentRoot: {
      background: 'rgb(255 255 255)',
      boxShadow: '0px 0px 10px rgba(0, 0, 0, 0.1)',
      boxSizing: 'border-box',
      borderRadius: 0,
      minHeight: '100vh',
      '&:last-child': {
        paddingBottom: theme.spacing.unit,
        paddingTop: 14,
      },
      '& h6': {
        fontWeight: 400,
        fontSize: 24,
        lineHeight: '22px',
        color: '#333333',
        paddingLeft:20,
      },
    },
    moreButton: {
      background: '#ECECEC',
      borderRadius: 4,
      color: '#666666',
      width: 'fit-content',
      padding: '0px 16px',
      height: 16,
      fontSize: 9,
      lineHeight: 1.8,
    },
    navigationButtonRoot: {
      backgroundColor: theme.palette.common.white,
      padding: theme.spacing.unit,
      paddingRight: theme.spacing.unit,
      marginBottom: theme.spacing.unit,
      height: theme.spacing.unit * 5,
      width: 270,
      marginTop: '5px',
      '& > span': {
        width: '260px',
        display: 'inline-block',
        whiteSpace: 'nowrap',
        textOverflow: 'ellipsis',
        overflow: 'hidden',
        fontWeight: theme.typography.fontWeightRegular,
        fontSize: theme.typography.fontSize,
        textAlign: 'left',
      },
      '& span  span': {
        paddingLeft: theme.spacing.unit / 2,
        paddingRight: theme.spacing.unit / 2,
        fontSize: '0.6rem',
        left: '12px',
        right: 'auto',
      },
    },
    navigationButtonEnd: {
      backgroundColor: '#54a9fc',
      padding: theme.spacing.unit,
      paddingRight: theme.spacing.unit,
      marginBottom: theme.spacing.unit,
      height: theme.spacing.unit * 5,
      '& > span': {
        display: 'inline-block',
        whiteSpace: 'nowrap',
        textOverflow: 'ellipsis',
        overflow: 'hidden',
        fontWeight: theme.typography.fontWeightRegular,
        fontSize: theme.typography.fontSize,
        textAlign: 'left',
      },
      '& span  span': {
        fontSize: '0.6rem',
        left: '12px',
        right: 'auto',
      },
    },
    buttonTag: {
      top: -11,
      left: 8,
      color: '#fff',
      padding: '5px 6px 4px 7px',
      position: 'absolute',
      borderRadius: 8,
      backgroundColor: '#999999',
      fontSize: 9,
      lineHeight: 1,
      textAlign: 'center',
      letterSpacing: '1px',
      fontWeight: 500,
    },
    goalScrolled: {
      maxHeight: '0px !important',
      overflow: 'hidden',
      transition: 'all 0.5s ease',
    },
    showMoreLink: {
      cursor: 'pointer',
      marginRight: theme.spacing.unit / 2,
    },
    csLoader: {
      zIndex: 999,
    },
    csLoaderInner: {
      transform: 'translateY(-50%)',
      top: '13%',
      width: 'calc(100% - 200px)',
      color: theme.palette.common.black,
      position: 'absolute',
      left: '167px',

      '& label': {
        fontSize: '9px',
        opacity: 0,
        display: 'inline-block',

        '&:nth-child(3)': {
          '-webkit-animation': 'lol 3s 300ms infinite ease-in-out',
          animation: 'lol 3s 300ms infinite ease-in-out',
        },

        '&:nth-child(2)': {
          '-webkit-animation': 'lol 3s 400ms infinite ease-in-out',
          animation: 'lol 3s 400ms infinite ease-in-out',
        },
        '&:nth-child(1)': {
          '-webkit-animation': 'lol 3s 500ms infinite ease-in-out',
          animation: 'lol 3s 500ms infinite ease-in-out',
        },
      },
    },

    '@keyframes lol': {
      '0%': {
        opacity: 0,
      },
      '33%': {
        opacity: 1,
      },
      '66%': {
        opacity: 1,
      },
      '100%': {
        opacity: 0,
      },
    },

    '@-webkit-keyframes lol': {
      '0%': {
        opacity: 0,
      },
      '33%': {
        opacity: 1,
      },
      '66%': {
        opacity: 1,
      },
      '100%': {
        opacity: 0,
      },
    },
    setHeight: {
      maxHeight: 280,
    },
    setHeightFull: {
      maxHeight: 'calc(100vh - 82px)',
    },
    link: {
      cursor: 'pointer',
    },
    showNext: {
      color: '#666666',
      opacity: 0.56,
      fontSize: 12,
    },
    activeChip: {
      '&::before': {
        position: 'absolute',
        background: '#CDE8FF',
        padding: '14px 16px 14px',
        content: '" "',
        left:0,
        width: "89%",
      },
    },
    coursesTruncate: {
      overflow: 'hidden',
      maxWidth: '200px',
      whiteSpace: 'nowrap',
      textOverflow: 'ellipsis',
      display: 'block',
      fontSize: '1rem',
      fontFamily: 'Nunito',
      lineHeight: '22px',
    },
    scrollbarContainer: {
      position: 'relative',
      height: 290,
    },
    scrollbarContainerFull:{
      height:'100%',
      position:'relative',
      overscrollBehavior: 'contain', 
      margin: 20,
      border: 'solid 1px rgba(230, 230, 230, 1)',
      borderRadius: 7     
    },
    browseTopicHeadingClose:{
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-between',
      alignItems: 'center',
      width: '100%',
    },
    topArrow: {
      '&:hover:after': {
        content: '""',
        position: 'absolute',
        left: '50%',
        marginLeft: -5,
        bottom: -7,
        width: 0,
        height: 0,
        borderLeft: '5px solid rgba(0, 0, 0, 0)',
        borderRight: '5px solid rgba(0, 0, 0, 0)',
        borderBottom: '8px solid rgb(0, 0, 0)',
      },
    },
    blueBgColor:{
      '&::before': {
        position: 'absolute',
        background: '#CDE8FF',
        padding: '14px 16px 14px',
        content: '" "',
        width: '100%',
        right: '4px',
      },
    },
    closeRgtBar:{
      cursor:'pointer',
    },
  });

const getClassName = (c: any) => {
  if (c && c.type === 'subject' && c.classIdToClassNameMap) {
    return '( ' + Object.values(c.classIdToClassNameMap).join(', ') + ' )';
  }
  return '';
};

function displayKeyFromLevel(level: string) {
  switch (level) {
    case 'course':
      return '';
    case 'subject':
      return 'Subjects';
    case 'sub-subject':
      return 'SubSubjects';
    case 'chapter':
      return 'Chapters';
    case 'concept':
      return 'Concepts';
    default:
      return '';
  }
}

//@ts-ignore
interface GoalsDrillerProps extends WithStyles<typeof styles> {
  classes: any;
  goalsDriller: GoalDrillerData;
  goaldsDrillerChanged: Function;
  getTopSpacing: Function;
  filterContent: ContentListFilterData;
  fromCourse: any;
  goals: any;
  handleGoalsSectionClick: (value: boolean) => void;
  alwaysFetchCoursesInGoalDriller?: boolean;
  isConcept?: boolean;
  isCourse?:boolean;
  isChapter?:boolean;
  selectedBucketType: string;
  handleGoalsDrillerToggle: Function;
}

interface GoalsDrillerState {
  loading: boolean;
  threeDot: Boolean;
  goalsDriller: GoalDrillerData;
  keyToShow: string;
  keyIdToShow: string;
  parentId: string;
  courses: CourseData[];
  lessCourses: CourseData[];
  showMore: boolean;
  subjects: {
    [key: string]: CourseSyllabusData[];
  };
  subSubjects: {
    [key: string]: CourseSyllabusData[];
  };
  chapters: {
    [key: string]: CourseSyllabusData[];
  };
  concepts: {
    [key: string]: CourseSyllabusData[];
  };
  dataLength: number;
  [key: string]: any;
  scrollPosition: number;
  areGoalsSectionOpened: boolean;
  isClicked: boolean;
  prevLevel: string;
  activeItemID: string;
  showTooltip: boolean;
  isClassNode: boolean;
  isChildNode: boolean;
  isSubjectTypeNode: boolean;
  isSubjectNode: boolean;
  isGoalNode: boolean;
  isArrowDown: boolean;
  goalsData: any[];
  courseData: any;
  isConcept: boolean;
  isBrowseByTopicTouched: boolean;
}


class GoalsDriller extends Component<GoalsDrillerProps, GoalsDrillerState> {
  initialLevel: string = '';
  timeout: any;
  timeout2: any;
  constructor(props: GoalsDrillerProps) {
    super(props);

    let keyIdToShow = '';
    let keyToShow = 'courses';

    //set preselected goal filter
    props = {
      ...props,
      goalsDriller: {
        level: 'course',
        course: {
          _id: '',
          name: '',
          courseItems: [],
          childCount: 0,
        },
        subject: {
          _id: '',
          name: '',
          childCount: 0,
        },
        subSubject: {
          _id: '',
          name: '',
          childCount: 0,
        },
        chapter: {
          _id: '',
          name: '',
          childCount: 0,
        },
        concept: {
          _id: '',
          name: '',
          childCount: 0,
        },
        ...props.goalsDriller,
      },
    };

    if (props.goalsDriller.level == 'subject') {
      keyIdToShow = props.goalsDriller.course ? props.goalsDriller.course._id : '';
      keyToShow = 'subjects';
    } else if (props.goalsDriller.level == 'sub-subject') {
      keyIdToShow = props.goalsDriller.course ? props.goalsDriller.course._id : '';
      keyToShow = 'subjects';
    } else if (props.goalsDriller.level == 'chapter') {
      keyToShow = 'chapters';
      keyIdToShow = props.goalsDriller.subSubject._id;
    } else if (props.goalsDriller.level == 'concept') {
      keyToShow = 'concepts';
      keyIdToShow = props.goalsDriller.chapter._id;
    }

    this.state = {
      ...this.state,
      loading: true,
      threeDot: true,
      collapseOnScroll: false,
      keyToShow: keyToShow,
      keyIdToShow: keyIdToShow,
      parentId: '',
      subjects: {},
      subSubjects: {},
      chapters: {},
      concepts: {},
      dataLength: 0,
      showMore: false,
      courses: props.goals,
      goalsDriller: _.cloneDeep(props.goalsDriller),
      scrollPosition: window.pageYOffset,
      areGoalsSectionOpened: true,
      isClicked: false,
      prevLevel: '',
      activeItemID: '',
      showTooltip: false,
      isClassNode: false,
      isChildNode: false,
      isSubjectTypeNode: false,
      isSubjectNode: false,
      isGoalNode: false,
      isArrowDown: true,
      goalsData: [],
      courseData: [],
      isConcept: this.props.isConcept ? true : false,
      isBrowseByTopicTouched: false,
    };

    this.initialLevel = props.goalsDriller.level;
    this.loadNext = this.loadNext.bind(this);
    this.renderChip = this.renderChip.bind(this);
    this.goForNextLevel = this.goForNextLevel.bind(this);
    this.getSelectedLevel = this.getSelectedLevel.bind(this);
    this.showMoreClick = this.showMoreClick.bind(this);
    this.cardClick = this.cardClick.bind(this);
    // this.handleBackButton = this.handleBackButton.bind(this);
    this.showNextStep == this.showNextStep.bind(this);
    this.handleHover = this.handleHover.bind(this);
    this.handleGoalNode = this.handleGoalNode.bind(this);
    this.handleChapterNode = this.handleChapterNode.bind(this);
    this.handleSubjectNode = this.handleSubjectNode.bind(this);
    this.handleSubSubjectNode = this.handleSubSubjectNode.bind(this);
    this.handleConceptNode = this.handleConceptNode.bind(this);
  }

  componentDidMount() {
    if (this.props.alwaysFetchCoursesInGoalDriller) {
      this.loadNext('course');
    } else {
      this.loadNext(_.get(this.props, 'goalsDriller.level', 'course'));
    }
  }

  componentDidUpdate(prevProps:any){
    if(prevProps.goalsDriller !== this.props.goalsDriller){
     this.setState({
       isConcept: false,
     })
    }
  }

  /* TODO: uncomment later */
  // componentWillReceiveProps(nextProps: GoalsDrillerProps){
  // 	if(this.props.filterContent.contentMenu !== nextProps.filterContent.contentMenu){
  // 		setTimeout(()=>{
  // 			this.loadNext(_.get(nextProps, "goalsDriller.level", "course"))
  // 		})
  // 	}
  // }

  transformCourses(courses: any, isArrowDown?: boolean) {
    return courses.map((course: any) => {
      return {
        course,
        subjects: [],
        isArrowDown: isArrowDown ? isArrowDown : false,
      };
    });
  }

  transformSubjects(subjects: any, courseId: string, isArrowDown?: boolean) {
    const { goalsData: courses = [] } = this.state;

    let index = courses.findIndex((c) => c.course._id === courseId);
    if (index != -1) {
      courses[index].subjects = subjects.map((subject: any) => {
        return {
          subject,
          subSubjects: [],
          isArrowDown: isArrowDown ? isArrowDown : false,
        };
      });
    }
    return courses;
  }

  transformSubSubjects(subSubjects: any, courseId: string, subjectId: string, isArrowDown?: boolean) {
    const { goalsData: courses = [] } = this.state;
    let cIndex = courses.findIndex((c) => c.course._id === courseId);
    if (cIndex != -1) {
      let sIndex = courses[cIndex].subjects.findIndex((s: any) => s.subject._id === subjectId);
      if (sIndex != -1) {
        courses[cIndex].subjects[sIndex].subSubjects = subSubjects.map((subSubject: any) => {
          return {
            subSubject,
            chapters: [],
            isArrowDown: isArrowDown ? isArrowDown : false,
          };
        });
      }
    }
    return courses;
  }

  transformChapters(chapters: any, courseId: string, subjectId: string, subSubjectId: string, isArrowDown?: boolean) {
    const { goalsData: courses = [] } = this.state;
    let cIndex = courses.findIndex((c) => c.course._id === courseId);
    if (cIndex != -1) {
      let sIndex = courses[cIndex].subjects.findIndex((s: any) => s.subject._id === subjectId);
      if (sIndex != -1) {
        let ssIndex = courses[cIndex].subjects[sIndex].subSubjects.findIndex(
          (ss: any) => ss.subSubject._id === subSubjectId
        );
        if (ssIndex != -1) {
          courses[cIndex].subjects[sIndex].subSubjects[ssIndex].chapters = chapters.map((chapter: any) => {
            return {
              chapter,
              concepts: [],
              isArrowDown: isArrowDown ? isArrowDown : false,
            };
          });
        }
      }
    }
    return courses;
  }

  transformConcepts(concepts: any, courseId: string, subjectId: string, subSubjectId: string, chapterId: string) {
    let { goalsData: courses = [] } = this.state;
    let cIndex = courses.findIndex((c) => c.course._id === courseId);
    if (cIndex != -1) {
      let sIndex = courses[cIndex].subjects.findIndex((s: any) => s.subject._id === subjectId);
      if (sIndex != -1) {
        let ssIndex = courses[cIndex].subjects[sIndex].subSubjects.findIndex(
          (ss: any) => ss.subSubject._id === subSubjectId
        );
        if (ssIndex != -1) {
          let chIndex = courses[cIndex].subjects[sIndex].subSubjects[ssIndex].chapters.findIndex(
            (ch: any) => ch.chapter._id === chapterId
          );
          if (chIndex != -1) {
            courses[cIndex].subjects[sIndex].subSubjects[ssIndex].chapters[chIndex].concepts = concepts.map(
              (concept: any) => {
                return {
                  concept,
                };
              }
            );
          }
        }
      }
    }
    return courses;
  }

  transformGoals(data: any, level: string, isArrowDown?: boolean) {
    const { goalsDriller } = this.props;

    switch (level) {
      case 'course':
        return this.transformCourses(data, isArrowDown);
      case 'subject':
        return this.transformSubjects(data, goalsDriller.course._id, isArrowDown);
      case 'sub-subject':
        return this.transformSubSubjects(data, goalsDriller.course._id, goalsDriller.subject._id, isArrowDown);

      case 'chapter':
        return this.transformChapters(
          data,
          goalsDriller.course._id,
          goalsDriller.subject._id,
          goalsDriller.subSubject._id,
          isArrowDown
        );

      case 'concept':
        return this.transformConcepts(
          data,
          goalsDriller.course._id,
          goalsDriller.subject._id,
          goalsDriller.subSubject._id,
          goalsDriller.chapter._id
        );
    }
  }

  /* TODO: uncomment later */
  // loadNext(level: string = "course", loadCount: boolean = false) {
  // 	let { goalsDriller, courses, subjects, subSubjects, chapters, concepts, showMore, threeDot } = this.state;
  // 	let { filterContent } = this.props;
  // 	let keyToShow = "";
  // 	let keyIdToShow = "";
  // 	let dataLength = 0;
  // 	let nextLevel = "";
  // 	let result: any[] = [];

  // 	return Promise.resolve()
  // 		/* .then(() => {

  // 			return Promise.resolve();
  // 		}) */
  // 		.then((): any => {
  // 			if (level == "course") {
  // 				goalsDriller.level = "course";
  // 				nextLevel = "subject";
  // 				keyToShow = "courses";
  // 				// if (!courses || courses.length == 0) {
  // 					return courseService.list()
  // 						.then((res: CourseData[]) => {
  // 							let goalsData = this.transformCourses(res)
  // 								this.setState({
  // 									goalsData
  // 								})
  // 							return Promise.resolve(res);
  // 						});
  // 				// } else {
  // 				// 	let goalsData = this.transformCourses(courses)
  // 				// 	this.setState({
  // 				// 		goalsData
  // 				// 	})
  // 				// 	return Promise.resolve(courses);
  // 				// }
  // 			} else if (level == "subject") {
  // 				goalsDriller.level = "subject";
  // 				nextLevel = "sub-subject";
  // 				keyToShow = "subjects";
  // 				keyIdToShow = goalsDriller.course._id;
  // 				// if (!subjects[keyIdToShow]) {
  // 					return courseService.getCourseSubject(goalsDriller.course._id)
  // 						.then((res: CourseSyllabusData[]) => {
  // 							let goalsData = this.transformSubjects(res, goalsDriller.course._id)
  // 							this.setState({
  // 								goalsData
  // 							})
  // 							return Promise.resolve(res);
  // 						});
  // 				// } else {
  // 				// 	return Promise.resolve(subjects[keyIdToShow]);
  // 				// }
  // 			} else if (level == "sub-subject") {
  // 				goalsDriller.level = "sub-subject";
  // 				nextLevel = "chapter";
  // 				keyToShow = "subSubjects";
  // 				keyIdToShow = goalsDriller.subject._id;
  // 				// if (!subSubjects[keyIdToShow]) {

  // 					return courseService.getCourseSubSubject(goalsDriller.course._id, goalsDriller.subject._id)
  // 						.then((res: CourseSyllabusData[]) => {
  // 							let goalsData = this.transformSubSubjects(
  // 								res,
  // 								goalsDriller.course._id,
  // 								goalsDriller.subject._id
  // 								)
  // 							this.setState({
  // 								goalsData
  // 							})
  // 							return Promise.resolve(res);
  // 						});
  // 				// } else {
  // 				// 	return Promise.resolve(subSubjects[keyIdToShow]);
  // 				// }
  // 			} else if (level == "chapter") {
  // 				goalsDriller.level = "chapter";
  // 				nextLevel = "concept";
  // 				keyToShow = "chapters";
  // 				keyIdToShow = goalsDriller.subSubject._id;
  // 				// if (!chapters[keyIdToShow]) {
  // 					return courseService.getCourseChapters(goalsDriller.course._id, goalsDriller.subSubject._id)
  // 						.then((res: CourseSyllabusData[]) => {
  // 							let goalsData = this.transformChapters(
  // 								res,
  // 								goalsDriller.course._id,
  // 								goalsDriller.subject._id,
  // 								goalsDriller.subSubject._id,
  // 								)
  // 							this.setState({
  // 								goalsData
  // 							})
  // 							return Promise.resolve(res);
  // 						});
  // 				// } else {
  // 				// 	return Promise.resolve(chapters[keyIdToShow]);
  // 				// }
  // 			} else if (level == "concept") {
  // 				goalsDriller.level = "concept";
  // 				nextLevel = "";
  // 				keyToShow = "concepts";
  // 				keyIdToShow = goalsDriller.chapter._id;
  // 				// if (!concepts[keyIdToShow]) {
  // 					return courseService.getCourseConcepts(goalsDriller.course._id, goalsDriller.subject._id, goalsDriller.chapter._id)
  // 						.then((res: CourseSyllabusData[]) => {
  // 							let goalsData = this.transformConcepts(
  // 								res,
  // 								goalsDriller.course._id,
  // 								goalsDriller.subject._id,
  // 								goalsDriller.subSubject._id,
  // 								goalsDriller.chapter._id,
  // 								)
  // 							this.setState({
  // 								goalsData
  // 							})
  // 							return Promise.resolve(res);
  // 						});
  // 				// } else {
  // 				// 	return Promise.resolve(concepts[keyIdToShow]);
  // 				// }
  // 			}

  // 			return Promise.resolve(this.state.concepts[keyIdToShow]);
  // 		})//.then(() => this.setState({goalsDriller}))
  // 		/* TODO:  uncomment later */
  // 		/* .then((res: any[]) => {
  // 			if (level == "course") {
  // 				//set the state of
  // 				this.setState({ [keyToShow]: res, lessCourses: res });
  // 				return Promise.resolve(res);
  // 			} else {
  // 				//set the state of
  // 				this.setState({ [keyToShow]: res });
  // 			}
  // 			return Promise.resolve(res);
  // 		}) */
  // 		.then((res: any[]) => {
  // 			result = res;
  // 			dataLength = result.length;
  // 			//if count is already loaded then don't load again

  // 			if (!loadCount && dataLength > 0 && (result[0].childCount || result[0].childCount == 0) && !threeDot) {
  // 				if (!(keyToShow == "courses" && showMore && dataLength > 18 && !result[18].childCount)) {
  // 					return Promise.resolve([]);
  // 				}
  // 			}
  // 			// need for concept too
  // 			// if (goalsDriller.level == "concept") {
  // 			// 	return Promise.resolve([]);
  // 			// }

  // 			//create promise of all count
  // 			// let course = goalsDriller.course;
  // 			// let promises: any[] = [];
  // 			// let tot_req: any[] = [];
  // 			// promises = _.map(res, c => {
  // 			// 	let filterContentCopy = _.cloneDeep(filterContent) || {};
  // 			// 	// if(!_.isEmpty(goalsDriller) && goalsDriller != undefined){
  // 			// 		filterContentCopy.goalsDriller = _.cloneDeep(goalsDriller);
  // 			// 	// }

  // 			// 	// @ts-ignore
  // 			// 	filterContentCopy.goalsDriller[(level == "sub-subject"? "subSubject": level)]._id = c._id;
  // 			// 	tot_req.push(filterContentCopy);
  // 			// 	// let parentId = c._id;
  // 			// 	// if (goalsDriller.level == "course") {
  // 			// 	// 	course = c;
  // 			// 	// 	parentId = "";
  // 			// 	// }
  // 			// 	// return courseService.getCountByType(nextLevel, course._id, parentId);
  // 			// 	return contentService.count(filterContentCopy);
  // 			// });
  // 			let filterContentCopy = _.cloneDeep(filterContent)
  // 			filterContentCopy.goalsDriller = _.cloneDeep(goalsDriller);

  // 			return contentService.countAll({ level: level, data: res.map(r => r._id), filterContent: filterContentCopy });
  // 			// return Promise.all(promises);
  // 		}).then((counts: any[]) => {
  // 			//set all result to array
  // 			counts.forEach((c, i) => {
  // 				result[i].childCount = c;
  // 			});

  // 			//if not course update index
  // 			/* let data = this.state[keyToShow];
  // 			let key = keyToShow;
  // 			if (level == "course") {
  // 				data = result
  // 				key = (keyToShow == "courses" && showMore ? keyToShow : "lessCourses")
  // 			} else {
  // 				data[keyIdToShow] = result
  // 			} */

  // 			//set the state of
  // 			// this.setState({ [key]: data, keyToShow, keyIdToShow, dataLength });
  // 		})
  // 		.then(() => {
  // 			this.setState({ goalsDriller/* , threeDot: false */ });

  // 		})
  // 		;
  // }
  setContentTypeSelected=async (lvl:'concept'|'chapter',result:any,goalsData:any,
    goalsDriller:GoalDrillerData,getCourseConcepts:any)=>{
      const{filterContent}=this.props;
    let filterContentCopy = _.cloneDeep(filterContent);
    filterContentCopy.goalsDriller = _.cloneDeep(goalsDriller);
    const counts = await contentService.countAll({
      level: lvl,
      data: getCourseConcepts.map((r: any) => r._id),
      filterContent: filterContentCopy,
    });
    counts &&
      counts.forEach((c: any, i: any) => {
        const { goalsDriller } = this.state;
        const  lvlContent  = goalsDriller[lvl];
        if (result[i]._id === lvlContent._id) {
          result[i].childCount = c;
        }
      });
    goalsData = this.transformGoals(result,lvl);
    let conceptId = this.getConceptId(goalsData,lvl);
    goalsDriller.level = lvl;
    this.setState({ goalsDriller, goalsData, activeItemID: conceptId, loading: false });
  }
  getCourseArrowTrue = (goalsData: any, id: any,level:string) => {
    const changeArrowGoalDataIndex = goalsData.findIndex((goal: any)=> goal[level]._id === id);
    if(changeArrowGoalDataIndex !=-1){
    goalsData[changeArrowGoalDataIndex].isArrowDown = true;
    }
    return goalsData;
  }
  loadNextForConcept = (level: string, indexObj: any) => {
    let {
      goalsDriller,
      courses,
      subjects,
      subSubjects,
      chapters,
      concepts,
      showMore,
      threeDot,
      goalsData,
      activeItemID,
    } = this.state;
    let { filterContent,isConcept, isCourse,isChapter } = this.props;
    let keyToShow = '';
    let keyIdToShow = '';
    let dataLength = 0;
    let nextLevel = '';
    let result: any[] = [];
    let key = level != 'course' ? 'data' : level;
    let isData = false;
    return Promise.resolve().then(async () => {
      goalsDriller.level = 'course';
      nextLevel = 'subject';
      keyToShow = 'courses';
      const courseList = await courseService.list(this.props.selectedBucketType);
      let goalsData: any = this.transformGoals(courseList, 'course', false);
      if(!isConcept && isCourse &&!isChapter){
         goalsData = this.getCourseArrowTrue(goalsData, goalsDriller.course._id,"course");
      }
      this.setState(
        {
          goalsDriller,
          goalsData,
        },
        async () => {
          const { goalsDriller } = this.state;
          let getCourseSyllabus = await courseService.getCourseSubject(goalsDriller.course._id);
          goalsData = this.transformGoals(getCourseSyllabus, 'subject', false);
          if(!isConcept && !isChapter && isCourse){
            this.setState({
              goalsDriller,
              goalsData,
              loading: false
            })
          }
          (isConcept||isChapter) && this.setState(
            {
              goalsDriller,
              goalsData,
            },
            async () => {
              let getCourseSubSubject = await courseService.getCourseSubSubject(
                this.state.goalsDriller.course._id,
                this.state.goalsDriller.subject._id
              );
              goalsData = this.transformGoals(getCourseSubSubject, 'sub-subject', false);
              this.setState(
                {
                  goalsDriller,
                  goalsData,
                  loading: false
                },
                async () => {
                  let getCourseChapters = await courseService.getCourseChapters(
                    this.state.goalsDriller.course._id,
                    this.state.goalsDriller.subSubject._id
                  );
                  goalsData = this.transformGoals(getCourseChapters, 'chapter', false);
                  if(!isConcept && isChapter){
                    result = getCourseChapters;
                    dataLength = result.length;
                    if (isData) {
                      return Promise.resolve([]);
                    }
                    this.setContentTypeSelected('chapter',result,goalsData,
                    goalsDriller,getCourseChapters);
                   }
                  isConcept && this.setState(
                    {
                      goalsData,
                      goalsDriller,
                      loading: false
                    },
                     async () => {
                      let getCourseConcepts = await courseService.getCourseConcepts(
                        this.state.goalsDriller.course._id,
                        this.state.goalsDriller.subject._id,
                        this.state.goalsDriller.chapter._id
                      );
                      result = getCourseConcepts;
                      dataLength = result.length;
                      if (isData) {
                        return Promise.resolve([]);
                      }
                      this.setContentTypeSelected('concept',result,goalsData,
                      goalsDriller,getCourseConcepts);
                    }
                  );
                }
              );
            }
          );
        }
      );
    });
  };

  getConceptId = (goalsData: any,lvl:string) => {
    let conceptId = ''
    goalsData.forEach((goal:any, courseIndex:number)=> {
      if (goal.subjects.length) {
        goal.subjects.forEach((subject:any, subjectIndex:number)=> {
          if (subject.subSubjects.length) {
            subject.subSubjects.forEach((subSubject:any, subSubjectIndex:number)=> {
              if (subSubject.chapters.length) {
                subSubject.chapters.forEach((chapter:any, chapterIndex:number)=> {
                  if (lvl==='chapter') {
                    if(chapter.chapter.hasOwnProperty('childCount')){ 
                     this.setIsArrowDown(goalsData, courseIndex, subjectIndex,subSubjectIndex, chapterIndex);
                     conceptId =  chapter._id;
                    }
                  }
                  else if (chapter.concepts.length) {
                    chapter.concepts.forEach((concept:any)=> {
                      if (concept.concept.hasOwnProperty('childCount')) {
                        this.setIsArrowDown(goalsData, courseIndex, subjectIndex,subSubjectIndex, chapterIndex);
                       conceptId =  concept.concept._id;
                      }
                    })
                  }
                })
              }
            })
          }
        })
      }
    })
    return conceptId;
  };

  setIsArrowDown=(goalsData:any, courseIndex:number, subjectIndex:number, subSubjectIndex:number, chapterIndex: number)=>{
goalsData[courseIndex].isArrowDown = true;
goalsData[courseIndex].subjects[subjectIndex].isArrowDown = true;
goalsData[courseIndex].subjects[subjectIndex].subSubjects[subSubjectIndex].isArrowDown = true;
goalsData[courseIndex].subjects[subjectIndex].subSubjects[subSubjectIndex].chapters[chapterIndex].isArrowDown = true;
  }

  loadNext(level: string = 'course', loadCount: boolean = false, indexObj: any = {}) {
    let {
      goalsDriller,
      courses,
      subjects,
      subSubjects,
      chapters,
      concepts,
      showMore,
      threeDot,
      goalsData,
      isConcept,
    } = this.state;
    let { filterContent, isCourse,isChapter } = this.props;
    if (!this.state.isBrowseByTopicTouched && ((isConcept && goalsDriller.level === 'concept' )
    || isCourse||isChapter)
     ) {
      return this.loadNextForConcept('concept', indexObj);
    }
    let keyToShow = '';
    let keyIdToShow = '';
    let dataLength = 0;
    let nextLevel = '';
    let result: any[] = [];
    let key = level != 'course' ? 'data' : level;
    let isData = false;
    return Promise.resolve()
      .then(
        (): any => {
          if (level == 'course') {
            goalsDriller.level = 'course';
            nextLevel = 'subject';
            keyToShow = 'courses';
            // if (!courses || courses.length == 0) {
            return courseService.list(this.props.selectedBucketType).then((res: CourseData[]) => {
              return Promise.resolve(res);
            });
            // } else {
            // 	return Promise.resolve(courses);
            // }
          } else if (level == 'subject') {
            goalsDriller.level = 'subject';
            nextLevel = 'sub-subject';
            keyToShow = 'subjects';
            keyIdToShow = goalsDriller.course._id;
            const { cIndex } = indexObj;
            let subjects = goalsData[cIndex] && goalsData[cIndex].subjects.length;
            if (!subjects) {
              return courseService.getCourseSubject(goalsDriller.course._id).then((res: CourseSyllabusData[]) => {
                return Promise.resolve(res);
              });
            } else {
              isData = true;
              return Promise.resolve([]);
            }
          } else if (level == 'sub-subject') {
            goalsDriller.level = 'sub-subject';
            nextLevel = 'chapter';
            keyToShow = 'subSubjects';
            keyIdToShow = goalsDriller.subject._id;
            const { cIndex, sIndex } = indexObj;

            let subSubjects = goalsData[cIndex] && goalsData[cIndex].subjects[sIndex].subSubjects.length;
            if (!subSubjects) {
              return courseService
                .getCourseSubSubject(goalsDriller.course._id, goalsDriller.subject._id)
                .then((res: CourseSyllabusData[]) => {
                  return Promise.resolve(res);
                });
            } else {
              isData = true;
              return Promise.resolve([]);
            }
          } else if (level == 'chapter') {
            goalsDriller.level = 'chapter';
            nextLevel = 'concept';
            keyToShow = 'chapters';
            keyIdToShow = goalsDriller.subSubject._id;
            const { cIndex, sIndex, ssIndex } = indexObj;
            let chapters = goalsData[cIndex] && goalsData[cIndex].subjects[sIndex].subSubjects[ssIndex].chapters.length;
            if (!chapters) {
              return courseService
                .getCourseChapters(goalsDriller.course._id, goalsDriller.subSubject._id)
                .then((res: CourseSyllabusData[]) => {
                  return Promise.resolve(res);
                });
            } else {
              isData = true;
              return Promise.resolve([]);
            }
          } else if (level == 'concept') {
            goalsDriller.level = 'concept';
            nextLevel = '';
            keyToShow = 'concepts';
            keyIdToShow = goalsDriller.chapter._id;
            const { cIndex, sIndex, ssIndex, chapIndex } = indexObj;
            let concepts =
              goalsData[cIndex] &&
              goalsData[cIndex].subjects[sIndex].subSubjects[ssIndex].chapters[chapIndex].concepts.length;
            if (!concepts) {
              return courseService
                .getCourseConcepts(goalsDriller.course._id, goalsDriller.subject._id, goalsDriller.chapter._id)
                .then((res: CourseSyllabusData[]) => {
                  return Promise.resolve(res);
                });
            } else {
              isData = true;
              return Promise.resolve([]);
            }
          }
        }
      )
      .then((res: any[]) => {
        result = res;
        dataLength = result.length;

        //if count is already loaded then don't load again
        // if (!loadCount && dataLength > 0 && (result[0].childCount || result[0].childCount == 0) && !threeDot) {
        // 	if (!(keyToShow == "courses" && showMore && dataLength > 18 && !result[18].childCount)) {
        // 		return Promise.resolve([]);
        // 	}
        // }
        // need for concept too
        // if (goalsDriller.level == "concept") {
        // 	return Promise.resolve([]);
        // }
        return Promise.resolve([]);
      })
      .then((counts: any[]) => {
        //set all result to array
        counts &&
          counts.forEach((c, i) => {
            result[i].childCount = c;
          });
        return isData;
      })
      .then((res) => {
        if (!res) {
          goalsData = this.transformGoals(result, level);
          this.setState({ goalsDriller, goalsData, loading: false });
        }
      }).finally(() => {
        this.setState({ loading: false })
      });
  }

  goForNextLevel(c: any, level: any, indexObj: any) {
    let { goalsDriller }: any = this.state;

    if (level == 'course') {
      goalsDriller.course = c;
      level = 'subject';
    } else if (level == 'subject') {
      goalsDriller.subject = c;
      level = 'sub-subject';
    } else if (level == 'sub-subject') {
      goalsDriller.subSubject = c;
      level = 'chapter';
    } else if (level == 'chapter') {
      goalsDriller.chapter = c;
      level = 'concept';
    } else {
      goalsDriller.concept = c;
      this.setState({
        activeItemID: c._id,
      });
      level = '';
    }
    if (level) {
      this.loadNext(level, false, indexObj);
    }
    if (this.props.goaldsDrillerChanged) {
      this.props.goaldsDrillerChanged(goalsDriller);
    }
  }
  /* TODO: uncomment later */
  // getSelectedLevel(level: string) {
  // 	const { goalsDriller } = this.state;
  // 	let { prevLevel } = this.state
  // 	//check if pre selected filter set then don't allow to override it.
  // 	if (this.initialLevel != "course") {
  // 		if (level == "course") {
  // 			return;
  // 		} else if (level == "subject") {
  // 			if (!["course", "subject"].includes(this.initialLevel)) {
  // 				return true;
  // 			}
  // 		} else if (level == "sub-subject") {
  // 			if (!["course", "subject", "sub-subject"].includes(this.initialLevel)) {
  // 				return true;
  // 			}
  // 		} else if (level == "chapter") {
  // 			if (!["course", "subject", "sub-subject", "chapter"].includes(this.initialLevel)) {
  // 				return true;
  // 			}
  // 		} else {
  // 			if (!["course", "subject", "sub-subject", "chapter", "concept"].includes(this.initialLevel)) {
  // 				return true;
  // 			}
  // 		}
  // 	}

  // 	//default state
  // 	let d = {
  // 		_id: "",
  // 		name: "",
  // 		childCount: 0
  // 	};

  // 	if (level == "course") {
  // 		goalsDriller.course = Object.assign({}, { ...d, courseItems: [], groupId: "", courseType: { name: "" } });
  // 		goalsDriller.subject = Object.assign({}, d);
  // 		goalsDriller.subSubject = Object.assign({}, d);
  // 		goalsDriller.chapter = Object.assign({}, d);
  // 		goalsDriller.concept = Object.assign({}, d);
  // 		prevLevel = ''
  // 	} else if (level == "subject") {
  // 		goalsDriller.subject = Object.assign({}, d);
  // 		goalsDriller.subSubject = Object.assign({}, d);
  // 		goalsDriller.chapter = Object.assign({}, d);
  // 		goalsDriller.concept = Object.assign({}, d);
  // 		prevLevel = 'course'
  // 	} else if (level == "sub-subject") {
  // 		goalsDriller.subSubject = Object.assign({}, d);
  // 		goalsDriller.chapter = Object.assign({}, d);
  // 		goalsDriller.concept = Object.assign({}, d);
  // 		prevLevel = 'subject'
  // 	} else if (level == "chapter") {
  // 		goalsDriller.chapter = Object.assign({}, d);
  // 		goalsDriller.concept = Object.assign({}, d);
  // 		prevLevel = 'sub-subject'
  // 	} else {
  // 		goalsDriller.concept = Object.assign({}, d);
  // 		prevLevel = 'chapter'
  // 	}

  // 	this.setState({
  // 		prevLevel
  // 	})

  // 	this.setState({ goalsDriller });
  // 	this.props.goaldsDrillerChanged(goalsDriller);
  // 	this.loadNext(level);
  // }

  getSelectedLevel(data: any, level: string, indexObj: any, isGoToNext: boolean) {
    let { goalsDriller }: any = this.state;

    //default state
    let d = {
      _id: '',
      name: '',
      childCount: 0,
    };

    if (level == 'course') {
      goalsDriller.course = Object.assign({}, { ...d, courseItems: [], groupId: '', courseType: { name: '' } });
      goalsDriller.subject = Object.assign({}, d);
      goalsDriller.subSubject = Object.assign({}, d);
      goalsDriller.chapter = Object.assign({}, d);
      goalsDriller.concept = Object.assign({}, d);
    } else if (level == 'subject') {
      goalsDriller.subject = Object.assign({}, d);
      goalsDriller.subSubject = Object.assign({}, d);
      goalsDriller.chapter = Object.assign({}, d);
      goalsDriller.concept = Object.assign({}, d);
    } else if (level == 'sub-subject') {
      goalsDriller.subSubject = Object.assign({}, d);
      goalsDriller.chapter = Object.assign({}, d);
      goalsDriller.concept = Object.assign({}, d);
    } else if (level == 'chapter') {
      goalsDriller.chapter = Object.assign({}, d);
      goalsDriller.concept = Object.assign({}, d);
    } else {
      goalsDriller.concept = Object.assign({}, d);
    }

    if (isGoToNext) {
      this.setState({ goalsDriller }, () => this.goForNextLevel(data, level, indexObj));
    } else {
      if (level == 'chapter') {
        level = 'sub-subject';
      } else if (level == 'sub-subject') {
        level = 'subject';
      } else if (level == 'subject') {
        level = 'course';
      } else level = '';
      if (level) goalsDriller.level = level;
      else goalsDriller = null;
      this.setState({ activeItemID: '' });
      this.props.goaldsDrillerChanged(goalsDriller);
    }
    // this.props.goaldsDrillerChanged(goalsDriller);
    // this.loadNext(level);
  }

  collapseAll(courses: any[], courseId: string, subjectId?: string, subSubjectId?: string, chapterId?: string) {
    return courses.map((c: any) => {
      if (c.course._id !== courseId) {
        c.isArrowDown = false;
      }
      c.subjects = c.subjects.map((s: any) => {
        if (s.subject._id != subjectId) {
          s.isArrowDown = false;
        }
        s.subSubjects = s.subSubjects.map((ss: any) => {
          if (ss.subSubject._id != subSubjectId) {
            ss.isArrowDown = false;
          }
          ss.chapters = ss.chapters.map((ch: any) => {
            if (ch.chapter._id != chapterId) {
              ch.isArrowDown = false;
            }
            return ch;
          });

          return ss;
        });

        return s;
      });

      return c;
    });
  }

  handleGoalNode(e: any, course: any, cIndex: number) {
    let { goalsData } = this.state;

    goalsData = this.collapseAll(goalsData, course.course._id);
    let level = 'course';
    let _course = goalsData[cIndex];
    _course.isArrowDown = !course.isArrowDown;
    // if(_course.isArrowDown) level = 'course'
    this.getSelectedLevel(course.course, level, { cIndex }, _course.isArrowDown);
    this.setState({ goalsData, isBrowseByTopicTouched: true });
  }

  handleSubjectNode(e: any, subject: any, cIndex: number, sIndex: number) {
    let { goalsData } = this.state;

    let courseId = goalsData[cIndex] && goalsData[cIndex].course._id;
    goalsData = this.collapseAll(goalsData, courseId, subject.subject._id);
    let level = 'subject';
    let _subject = goalsData[cIndex] && goalsData[cIndex].subjects[sIndex];
    _subject.isArrowDown = !subject.isArrowDown;
    // if(_subject.isArrowDown) level = 'subject'
    this.getSelectedLevel(subject.subject, level, { cIndex, sIndex }, _subject.isArrowDown);
    this.setState({ goalsData, isBrowseByTopicTouched: true  });
  }

  handleSubSubjectNode(e: any, subSubject: any, cIndex: number, sIndex: number, ssIndex: number) {
    let { goalsData } = this.state;

    let courseId = goalsData[cIndex] && goalsData[cIndex].course._id;
    let subjectId = goalsData[cIndex] && goalsData[cIndex].subjects[sIndex].subject._id;
    goalsData = this.collapseAll(goalsData, courseId, subjectId, subSubject.subSubject._id);
    let level = 'sub-subject';
    let _subSubject = goalsData[cIndex] && goalsData[cIndex].subjects[sIndex].subSubjects[ssIndex];
    _subSubject.isArrowDown = !subSubject.isArrowDown;
    // if(_subSubject.isArrowDown) level = 'sub-subject'
    this.getSelectedLevel(subSubject.subSubject, level, { cIndex, sIndex, ssIndex }, _subSubject.isArrowDown);
    this.setState({ goalsData, isBrowseByTopicTouched: true  });
  }

  handleChapterNode(e: any, chapter: any, cIndex: number, sIndex: number, ssIndex: number, chapIndex: number) {
    let { goalsData } = this.state;

    let courseId = goalsData[cIndex] && goalsData[cIndex].course._id;
    let subjectId = goalsData[cIndex] && goalsData[cIndex].subjects[sIndex].subject._id;
    let subSubjectId = goalsData[cIndex] && goalsData[cIndex].subjects[sIndex].subSubjects[ssIndex].subSubject._id;
    goalsData = this.collapseAll(goalsData, courseId, subjectId, subSubjectId, chapter.chapter._id);
    let level = 'chapter';
    let _chapter = goalsData[cIndex] && goalsData[cIndex].subjects[sIndex].subSubjects[ssIndex].chapters[chapIndex];
    _chapter.isArrowDown = !chapter.isArrowDown;
    // if(_chapter.isArrowDown) level = 'chapter'
    this.getSelectedLevel(chapter.chapter, level, { cIndex, sIndex, ssIndex, chapIndex }, _chapter.isArrowDown);
    this.setState({ goalsData , isBrowseByTopicTouched: true });
  }

  handleConceptNode(e: any, concept: any) {
    const { activeItemID } = this.state;

    if (activeItemID !== concept.concept._id) this.getSelectedLevel(concept.concept, 'concept', {}, true);
    // this.setState({isClassNode: !this.state.isClassNode, isArrowDown: !this.state.isArrowDown});
  }

  // renderChip() {
  // 	const { classes, goalsDriller: preGoalsDriller } = this.props;
  // 	const { goalsDriller, keyIdToShow, isChildNode, isArrowDown, isClassNode, isSubjectTypeNode, isSubjectNode
  // 		,showMore, activeItemID, showTooltip } = this.state;
  // 	let { keyToShow } = this.state;

  // 	// if (keyToShow == "courses" && !showMore) {
  // 	// 	keyToShow = "lessCourses";
  // 	// }
  // 	let course = goalsDriller.course;
  // 	let data = this.state[keyToShow];
  // 	if (goalsDriller.level != "course") {
  // 		data = data[keyIdToShow];
  // 	}
  // 	if (goalsDriller.includedIds && this.initialLevel == goalsDriller.level) {
  // 		data = _.filter(data, (d: any) => {
  // 			return goalsDriller.includedIds.includes(d._id)
  // 		});
  // 	}

  // 	const checkChildCount = (data: any) => {
  // 		let returnData = true;
  // 		if (data['childCount'] !== "") {
  // 			returnData = false;
  // 		}

  // 		return returnData;
  // 	}

  // 	return _.map(data, (c: any, i: number) => {
  // 		if (!c.childCount && c.childCount != 0) {
  // 			c.childCount = "";
  // 		}

  // 		if (goalsDriller.level == "course") {
  // 			course = c;
  // 		}

  // 		if (c.childCount == "" && goalsDriller.level != "concept") {
  // 		}

  // 		return (
  // 			<>
  // 				{/* <Grid className={classes.goalLevelList}>
  // 					<ul className={classes.tree}>
  // 						<li>
  // 							<span>{
  // 								isArrowDown ?
  // 									<KeyboardArrowRightIcon /> :
  // 									<KeyboardArrowDownIcon />}
  // 							</span>

  // 							<span>
  // 								<img src="/assets/svg/myLibrary/goalLevel/goal-icon.svg" alt="goal-icon" />
  // 							</span>
  // 							<label className={classes.treeToggleLabel} id="goal"
  // 								onClick={(e: any) => this.handleGoalNode(e.target.id)}>
  // 								<span>BITSAT <span>(94682)</span></span>
  // 							</label>
  // 							<ul className={[classes.subTree, isChildNode ? classes.hideChildNode : classes.showChildNode].join(' ')}>
  // 								<li>
  // 									<span>{
  // 										isArrowDown ?
  // 											<KeyboardArrowRightIcon /> :
  // 											<KeyboardArrowDownIcon />}
  // 									</span>
  // 									<span>
  // 										<img src="/assets/svg/myLibrary/goalLevel/subject-icon.svg" alt="subject-icon" />
  // 									</span>
  // 									<label className={classes.treeToggleLabel} id="secondLabel"
  // 										onClick={(e: any) => this.handleSubjectNode(e.target.id)}>
  // 										<span>Chemistry 11th & 12th <span>(94682)</span></span>
  // 									</label>
  // 									<ul className={[classes.subTree, isSubjectNode ? classes.hideChildNode : classes.showChildNode].join(' ')}>
  // 										<li>
  // 											<span>{
  // 												isArrowDown ?
  // 													<KeyboardArrowRightIcon /> :
  // 													<KeyboardArrowDownIcon />}
  // 											</span>
  // 											<span>
  // 												<img src="/assets/svg/myLibrary/goalLevel/subject-type-icon.svg" alt="icon" />
  // 											</span>
  // 											<label className={classes.treeToggleLabel}
  // 												onClick={(e: any) => this.handleSubjectTypeNode(e.target.id)}>
  // 												<span>Chemistry <span>(94682)</span></span>
  // 											</label>

  // 											<ul className={[classes.subTree, isSubjectTypeNode ? classes.hideChildNode : classes.showChildNode].join(' ')}>
  // 												<li>
  // 													<span>{
  // 														isArrowDown ?
  // 															<KeyboardArrowRightIcon /> :
  // 															<KeyboardArrowDownIcon />}
  // 													</span>
  // 													<span>
  // 														<img src="/assets/svg/myLibrary/goalLevel/sub-subject-icon.svg" alt="icon" />
  // 													</span>
  // 													<label className={classes.treeToggleLabel}
  // 														onClick={(e: any) => this.handleClassNode(e.target.id)}>
  // 														<span>Inorganic Chemistry <span>(94682)</span></span>
  // 													</label>

  // 													<ul className={[classes.subTree, isClassNode ? classes.hideChildNode : classes.showChildNode].join(' ')}>
  // 														<li>
  // 															<span>
  // 																<img src="/assets/svg/myLibrary/goalLevel/subject-topics-icon.svg" alt="icon" />
  // 															</span>
  // 															<label className={classes.treeToggleLabel}>
  // 																<span>Chemistry in everyday life</span> <span>(94682)</span>
  // 															</label>
  // 														</li>
  // 													</ul>
  // 												</li>
  // 											</ul>
  // 										</li>
  // 									</ul>
  // 								</li>
  // 							</ul>
  // 						</li>
  // 					</ul>
  // 				</Grid> */}
  // 				{/* JUSt Commented code to check existing functionality */}
  // 				<List
  // 					dense={true}
  // 					key={i}
  // 					className={cx(c._id == activeItemID ? classes.activeChip : "", classes.categoryListItem, (goalsDriller.level == 'course' && classes.tooltipArrow))}
  // 					onClick={() => { this.goForNextLevel(c) }}
  // 				>
  // 					<ListItem>
  // 						<ListItemText>
  // 							<span
  // 								className={classes.coursesTruncate}
  // 								onMouseOver={(e) => { this.handleHover(e) }}
  // 								onMouseOut={(e) => { this.handleHover(e) }}>
  // 								{c.courseType ? c.courseType.name : c.name} {getClassName(c)}
  // 							</span>

  // 							{
  // 								checkChildCount(c)
  // 									? <div className={classes.csLoader}>
  // 										<div className={classes.csLoaderInner}>
  // 											<label>&#9679;</label>
  // 											<label>&#9679;</label>
  // 											<label>&#9679;</label>
  // 										</div>
  // 									</div>
  // 									: <Typography variant="caption" className={classes.buttonTag}>
  // 										{c.childCount}
  // 									</Typography>
  // 							}
  // 						</ListItemText>
  // 						{
  // 							keyToShow != 'concepts' && (
  // 								<ListItemSecondaryAction>
  // 									<IconButton style={{ float: 'right' }} aria-label="delete">
  // 										<ArrowForwardIosIcon fontSize='small' height='1.5em' classes={{ root: classes.textColor }} />
  // 									</IconButton>
  // 								</ListItemSecondaryAction>
  // 							)
  // 						}
  // 					</ListItem>
  // 					</List>
  // 					{/* { just for the future use
  // 					(keyToShow == 'concepts' && showTooltip) &&
  // 					<CustomInfoIcon
  // 						isInfoIcon={false}
  // 						isCenterArrow={true}
  // 						isRightArrow={false}
  // 						knowMoreAbout={false}
  // 						details={c.name}
  // 						toolTipDirection="top" />
  // 					}
  // 					<div className="tooltipContainer">
  // 						<CustomInfoIcon
  // 							isInfoIcon={false}
  // 							isCenterArrow={true}
  // 							isRightArrow={false}
  // 							knowMoreAbout={false}
  // 							details={c.courseType ? c.courseType.name : c.name}
  // 							toolTipDirection="top" />
  // 					</div>
  // 					*/}
  // 			</>
  // 		)
  // 	})
  // }

  checkImage = async (name: string) => {
    let src = `/assets/svg/myLibrary/${name}.svg`;
    let isImage = await this._fetchImage(src);
    return isImage;
  };

  _fetchImage(src: any) {
    return new Promise((resolve: any, reject: any) => {
      fetch(src, { method: 'HEAD' })
        .then((res: any) => {
          if (res.ok) {
            return resolve(true);
          } else {
            return reject(false);
          }
        })
        .catch((err: any) => {
          return reject(false);
        });
    });
  }
  checkIsAnyChildArrowDown=(sampleObject:any [])=>{
		// console.log(sampleObject);
		// for(let sample in sampleObject){
		// 	console.log({sample});
		// 	// @ts-ignore
        //        if(sample.isArrowDown){
        //           return true;
		// 	   }
		// }
		for(let indx=0; indx<sampleObject.length; indx++){
			if(sampleObject[indx].isArrowDown){
				return true;
			}
		}
	  return false;	
	}
  checkConcepts=(concepts:any [])=>{
    for(let indx=0; indx<concepts.length; indx++){
			if(concepts[indx].isArrowDown||concepts[indx].concept._id===this.state.activeItemID){
				return true;
			}
		}
    return false;
  }
  renderChip() {
    const { classes, goalsDriller: preGoalsDriller } = this.props;
    const {
      goalsDriller,
      keyIdToShow,
      isChildNode,
      isArrowDown,
      isClassNode,
      isSubjectTypeNode,
      isSubjectNode,
      showMore,
      activeItemID,
      showTooltip,
    } = this.state;
    let { keyToShow, goalsData: courses = [] } = this.state;

    let _checkChildCount = (data: any) => {
      if (data.childCount !== undefined) {
        let res = data.childCount;
        return '(' + res + ')';
      }
      return '...';
    };
    let renderCourses = (courses: any = []) => {
      return courses.map((course: any, cIndex: number) => {
        const courseName = course.course.courseType ? course.course.courseType.name : course.course.name;
        const showBlueBg=course.isArrowDown	&& !this.checkIsAnyChildArrowDown(course.subjects);
        return (
          <li key={course.course._id}>
            <Grid
              container
              className={cx(classes.goalListItem, 
                showBlueBg && classes.blueBgColor
             )}  
              onClick={(e: any) => this.handleGoalNode(e.target.id, course, cIndex)}
            >
              <span>{course.isArrowDown ? <KeyboardArrowDownIcon /> : <KeyboardArrowRightIcon />}</span>

              <span>
                <img src='/assets/svg/myLibrary/goalLevel/goal-icon.svg' alt='goal-icon' />
              </span>
              <label className={classes.treeToggleLabel} id='goal'>
                <span>{course.course.courseType ? course.course.courseType.name : course.course.name} </span>
                {/* <span>{_checkChildCount(course.course)}</span> */}
              </label>
              {courseName.length > 20 && (
                <Grid className='tooltip'>
                  <span>{course.course.courseType ? course.course.courseType.name : course.course.name} </span>
                  {/* <span>{_checkChildCount(course.course)}</span> */}
                </Grid>
              )}
            </Grid>

            {/* <ul className={[classes.subTree, isChildNode ? classes.hideChildNode : classes.showChildNode].join(' ')}> */}
            {course.isArrowDown && <ul>{renderSubjects(course.subjects, cIndex)}</ul>}
          </li>
        );
      });
    };
    let renderSubjects = (subjects: any = [], cIndex: number) => {
      return subjects.map((subject: any, sIndex: number) => {
        let subjectName = subject.subject.name
          .split(' ')
          .join('')
          .toLowerCase();
        let _subjectName = subject.subject.name + '' + (subject.subject.parent ? subject.subject.parent.name : '');
        const showBlueBg=subject.isArrowDown	&& !this.checkIsAnyChildArrowDown(subject.subSubjects);
        return (
          <li key={subject.subject._id}>
            <Grid
              container
              className={cx(classes.goalListItem, 
                showBlueBg && classes.blueBgColor
             )}  
              onClick={(e: any) => this.handleSubjectNode(e.target.id, subject, cIndex, sIndex)}
            >
              <span>{subject.isArrowDown ? <KeyboardArrowDownIcon /> : <KeyboardArrowRightIcon />}</span>
              <span>
                {iconsForSubjects[subjectName] ? (
                  <img src={`/assets/svg/myLibrary/${subjectName}.svg`} alt='subject-icon' />
                ) : (
                  <Avatar className={classes.purple}>{this.extractCharacters(subject.subject.name)}</Avatar>
                )}
              </span>
              <label className={classes.treeToggleLabel} id='secondLabel'>
                <span>
                  {subject.subject.name} {subject.subject.parent ? subject.subject.parent.name : ''}{' '}
                  {/* <span>{_checkChildCount(subject.subject)}</span> */}
                </span>
              </label>
              {_subjectName.length > 15 && (
                <Grid className='tooltip'>
                  <span>
                    {subject.subject.name}
                    {subject.subject.parent ? subject.subject.parent.name : ''}{' '}
                  </span>
                  {/* <span>{_checkChildCount(subject.subject)}</span> */}
                </Grid>
              )}
            </Grid>
            {/* <ul className={[classes.subTree, isSubjectNode ? classes.hideChildNode : classes.showChildNode].join(' ')}> */}
            {subject.isArrowDown && <ul>{renderSubSubjects(subject.subSubjects, cIndex, sIndex)}</ul>}
          </li>
        );
      });
    };
    let renderSubSubjects = (subSubjects: any = [], cIndex: number, sIndex: number) => {
      return subSubjects.map((subSubject: any, ssIndex: number) => {
        const subSubjectName = subSubject.subSubject.name;
        const showBlueBg=subSubject.isArrowDown	&& !this.checkIsAnyChildArrowDown(subSubject.chapters);
        return (
          <li>
            <Grid
              container
              className={cx(classes.goalListItem, 
                showBlueBg && classes.blueBgColor
             )}  
              onClick={(e: any) => this.handleSubSubjectNode(e.target.id, subSubject, cIndex, sIndex, ssIndex)}
            >
              <span>{subSubject.isArrowDown ? <KeyboardArrowDownIcon /> : <KeyboardArrowRightIcon />}</span>
              <span>
                <img src='/assets/svg/myLibrary/goalLevel/subject-type-icon.svg' alt='icon' />
              </span>
              <label className={classes.treeToggleLabel}>
                <span>
                  {subSubject.subSubject.name} 
                  {/* <span>{_checkChildCount(subSubject.subSubject)}</span> */}
                </span>
              </label>
              {subSubjectName.length > 20 && (
                <Grid className='tooltip'>
                  <span>{subSubject.subSubject.name} </span>
                  {/* <span>{_checkChildCount(subSubject.subSubject)}</span> */}
                </Grid>
              )}
            </Grid>

            {/* <ul className={[classes.subTree, isSubjectTypeNode ? classes.hideChildNode : classes.showChildNode].join(' ')}> */}
            {subSubject.isArrowDown && <ul>{renderChapters(subSubject.chapters, cIndex, sIndex, ssIndex)}</ul>}
          </li>
        );
      });
    };
    let renderChapters = (chapters: any = [], cIndex: number, sIndex: number, ssIndex: number) => {
      return chapters.map((chapter: any, chapIndex: number) => {
        const chapterName = chapter.chapter.name;
        const showBlueBg=chapter.isArrowDown && !this.checkConcepts(chapter.concepts);
        return (
          <li>
            <Grid
              container
              className={cx(classes.goalListItem, 
                showBlueBg && classes.blueBgColor
             )}  
              onClick={(e: any) => this.handleChapterNode(e.target.id, chapter, cIndex, sIndex, ssIndex, chapIndex)}
            >
              <span>{chapter.isArrowDown ? <KeyboardArrowDownIcon /> : <KeyboardArrowRightIcon />}</span>
              <span>
                <img src='/assets/svg/myLibrary/goalLevel/subject-topics-icon.svg' alt='icon' />
              </span>
              <label className={classes.treeToggleLabel}>
                <span>
                  {chapter.chapter.name} 
                  {/* <span>{_checkChildCount(chapter.chapter)}</span> */}
                </span>
              </label>
              {chapterName.length > 20 && (
                <Grid className='tooltip'>
                  <span>{chapter.chapter.name} </span>
                  {/* <span>{_checkChildCount(chapter.chapter)}</span> */}
                </Grid>
              )}
            </Grid>

            {/* <ul className={[classes.subTree, isClassNode ? classes.hideChildNode : classes.showChildNode].join(' ')}> */}
            {chapter.isArrowDown && <ul>{renderConcepts(chapter.concepts)}</ul>}
          </li>
        );
      });
    };
    let renderConcepts = (concepts: any = []) => {
      return concepts.map((concept: any) => {
        const conceptName = concept.concept.name;
        return (
          <li className={concept.concept._id == activeItemID ? classes.activeChip : ' '}>
            <Grid
              container
              className={classes.goalListItem}  
              onClick={(e: any) => this.handleConceptNode(e.target.id, concept)}
            >
              <span className={classes.paddingLeftMD}>
                {/* <img src="/assets/svg/myLibrary/goalLevel/subject-topics-icon.svg" alt="icon" /> */}
              </span>
              &nbsp;&nbsp;
              <label className={true && classes.treeToggleLabel}>
                <span>{concept.concept.name}</span> 
                {/* <span>{_checkChildCount(concept.concept)}</span> */}
              </label>
              {conceptName.length > 20 && (
                <Grid className='tooltip'>
                  <span>{concept.concept.name} </span>
                  {/* <span>{_checkChildCount(concept.concept)}</span> */}
                </Grid>
              )}
            </Grid>
          </li>
        );
      });
    };
    // courses.map((course: any) => {
    return (
      <>
        <Grid className={classes.goalLevelList}>
          <ul className={classes.tree}>{renderCourses(courses)}</ul>
        </Grid>
        {/* JUSt Commented code to check existing functionality */}
        {/* <List  
						dense={true}
						key={i}
						className={cx(c._id == activeItemID ? classes.activeChip : "", classes.categoryListItem, (goalsDriller.level == 'course' && classes.tooltipArrow))}
						onClick={() => { this.goForNextLevel(c) }}
					>
						<ListItem>
							<ListItemText>
								<span
									className={classes.coursesTruncate}
									onMouseOver={(e) => { this.handleHover(e) }}
									onMouseOut={(e) => { this.handleHover(e) }}>
									{c.courseType ? c.courseType.name : c.name} {getClassName(c)}
								</span>

								{
									checkChildCount(c)
										? <div className={classes.csLoader}>
											<div className={classes.csLoaderInner}>
												<label>&#9679;</label>
												<label>&#9679;</label>
												<label>&#9679;</label>
											</div>
										</div>
										: <Typography variant="caption" className={classes.buttonTag}>
											{c.childCount}
										</Typography>
								}
							</ListItemText>
							{
								keyToShow != 'concepts' && (
									<ListItemSecondaryAction>
										<IconButton style={{ float: 'right' }} aria-label="delete">
											<ArrowForwardIosIcon fontSize='small' height='1.5em' classes={{ root: classes.textColor }} />
										</IconButton>
									</ListItemSecondaryAction>
								)
							}
						</ListItem>
						</List> */}
      </>
    );
    // })

    // })
  }

  getTopSpacing() {
    const header: any = document.querySelector('header');
    const libraryHeader: any = document.querySelector('#sticky-header-filter');
    const myLibraryHeader: any = document.querySelector('#mylibrary-header');

    if (header && libraryHeader && myLibraryHeader) {
      return header.clientHeight + libraryHeader.clientHeight + myLibraryHeader.clientHeight;
    } else {
      return 0;
    }
  }
  //  prevScrollpos = window.pageYOffset;

  // scrollPosition = window.pageYOffset || document.documentElement.scrollTop

  showMoreClick() {
    const { showMore } = this.state;

    this.setState({ showMore: !showMore, threeDot: true });
    setTimeout(() => {
      this.loadNext(_.get(this.props, 'goalsDriller.level', 'course'));
    }, 1000);
  }

  cardClick() {
    const { collapseOnScroll } = this.state;

    this.setState({ collapseOnScroll: !collapseOnScroll });
  }

  // handleBackButton() {
  // 	const { prevLevel } = this.state
  // 	if (prevLevel) {
  // 		this.getSelectedLevel(prevLevel)
  // 	}
  // }

  showNextStep() {
    const { goalsDriller } = this.state;

    let { prevLevel } = this.state;

    // @ts-ignore
    if (prevLevel) {
      if (prevLevel == 'course') {
        return goalsDriller[prevLevel].courseType.name
          ? goalsDriller[prevLevel].courseType.name
          : goalsDriller[prevLevel].name;
      }
      if (prevLevel == 'sub-subject') {
        prevLevel = 'subSubject';
      }
      // @ts-ignore
      return goalsDriller[prevLevel].name;
    } else {
      return 'Goals';
    }
  }

  handleHover(data: any) {
    if (data === 'concept')
      this.setState({
        showTooltip: !this.state.showTooltip,
      });
  }

  extractCharacters = (str: string) => {
    let _str = '';
    str.split(' ').map((s) => {
      _str += s[0].toUpperCase();
    });
    return _str;
  };

  render() {
    const { classes, fromCourse, handleGoalsDrillerToggle } = this.props;
    const {
      goalsDriller,
      showTooltip,
      keyToShow,
      keyIdToShow,
      dataLength,
      loading,
      collapseOnScroll,
      showMore,
      courses,
    } = this.state;
    return (
      <>
        {/* JUST Commented	May Be Use LATER */}
        {/* <ul className={[classes.ulDefault, classes.goalsCategoriesNav].join(' ')}>
					
					{
						(_.isEmpty(goalsDriller.course._id) ? "" : (
							<li className={[classes.listItem, classes.paddingZero].join(' ')}>
								<Link onClick={(e: React.MouseEvent<HTMLElement>) => { e.preventDefault(); this.getSelectedLevel("subject"); }}
									classes={{ root: fromCourse ? "" : classes.linkItem }} underline="always"
								>

									{goalsDriller.course.courseType ? goalsDriller.course.courseType.name : goalsDriller.course.name}

								</Link>
								&nbsp;
								<ArrowForwardIosIcon color='default' className={[classes.fontSizeSM, classes.textColor].join(' ')} />
								&nbsp;
							</li>
						))
					}
					{
						(_.isEmpty(goalsDriller.subject._id) ? "" : (
							<li className={[classes.listItem, classes.paddingZero].join(' ')}>
								<Link onClick={(e: React.MouseEvent<HTMLElement>) => { e.preventDefault(); this.getSelectedLevel("sub-subject"); }}
									classes={{ root: fromCourse ? "" : classes.linkItem }} underline="always">
									{goalsDriller.subject.name}
								</Link>
								&nbsp;
								<ArrowForwardIosIcon color='default' className={[classes.fontSizeSM, classes.textColor].join(' ')} />
								&nbsp;
							</li>
						))
					}
					{
						(_.isEmpty(goalsDriller.subSubject._id) ? "" : (
							<li className={[classes.listItem, classes.paddingZero].join(' ')}>
								<Link onClick={(e: React.MouseEvent<HTMLElement>) => { e.preventDefault(); this.getSelectedLevel("chapter"); }}
									classes={{ root: fromCourse ? "" : classes.linkItem }} underline="always">
									{goalsDriller.subSubject.name}
								</Link>
								&nbsp;
								<ArrowForwardIosIcon color='default' className={[classes.fontSizeSM, classes.textColor].join(' ')} />
								&nbsp;
							</li>
						))
					}
					{
						(_.isEmpty(goalsDriller.chapter._id) ? "" : (
							<li className={[classes.listItem, classes.paddingZero].join(' ')}>
								<Link onClick={(e: React.MouseEvent<HTMLElement>) => { e.preventDefault(); this.getSelectedLevel("concept"); }}
									classes={{ root: fromCourse ? "" : classes.linkItem }} underline="always">
									{goalsDriller.chapter.name}
								</Link>
								&nbsp;
								<ArrowForwardIosIcon color='default' className={[classes.fontSizeSM, classes.textColor].join(' ')} />
								&nbsp;
							</li>
						))
					}
					{
						(_.isEmpty(goalsDriller.concept._id) ? "" : (
							<li className={[classes.listItem, classes.paddingZero, classes.truncateList, classes.fontSizeSM, classes.textColor].join(' ')}>
								<Link onClick={(e: React.MouseEvent<HTMLElement>) => { e.preventDefault(); }}
									classes={{ root: fromCourse ? "" : classes.linkItem }} underline="none">
									{goalsDriller.concept.name}
								</Link>
							</li>
						))
					}
				</ul> */}

        <Card className={[classes.marginBottomTop2x, classes.cardContainer, classes.noBorderRadius].join(' ')}>
          {//show local loader if loading goals
          loading ? <MyPATLocalLoader /> : ''}

          <CardContent className={[classes.cardContentRoot, classes.goalListBlock].join(' ')}>
            {/* TODO: uncomment later */}
            <Grid
              className={cx({
                [classes.currentLevel]: true,
                [classes.setHeight]: true,
                [classes.goalScrolled]: collapseOnScroll,
              })}
            >
              <div className={classes.browseTopicHeadingClose}>
                <Typography variant='h6'>Browse by Topics</Typography>
                <span className={classes.closeRgtBar} onClick={() => handleGoalsDrillerToggle()} ><img src="/assets/svg/closeRgtSideBar.svg" alt='Close' /></span>
                {/* <span className={classes.listTruncate}>{this.showNextStep()}</span>&nbsp;
							<span className={cx({ [classes.listTruncate]: false, [classes.showNext]: true })}>
								{displayKeyFromLevel(goalsDriller.level)} ({dataLength})</span> */}
              </div>
              {/* {goalsDriller.level !== 'course' &&
								<div style={{ float: 'right' }}><Link className={classes.link} onClick={this.handleBackButton}> Back </Link></div>
							} */}
            </Grid>
            <PerfectScrollbar className={[classes.paddingSM, classes.scrollbarContainerFull].join(' ')}>
              <div>{this.renderChip()}
              </div>
            </PerfectScrollbar>
            {/* TODO: uncomment later */}
            {/* {
							(
								<Grid container justify="center">
									<Grid item>
										<Typography variant="body1" color="primary" align="center" className={classes.moreButton}>
											0 More Chapters <span><ExpandMoreIcon /></span>
										</Typography>
									</Grid>
								</Grid>
							)
						} */}
            {/* {
							keyToShow == "courses" && courses && courses.length > 18 && (
								<Typography variant="body1" color="primary" align="center"
									onClick={this.showMoreClick}
									className={cx({ [classes.showMoreLink]: true, [classes.goalScrolled]: collapseOnScroll })}
								>
									{showMore ? "show less" : "show more"}
								</Typography>
							)
						} */}
          </CardContent>
        </Card>
      </>
    );
  }
}

// @ts-ignore
export default withStyles(styles)(GoalsDriller);
